import { render, staticRenderFns } from "./TeachPoint.vue?vue&type=template&id=bac7d29e"
import script from "./TeachPoint.vue?vue&type=script&lang=js"
export * from "./TeachPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports